import { render, staticRenderFns } from "./VueTabs.vue?vue&type=template&id=ad8933de&scoped=true&"
import script from "./VueTabs.vue?vue&type=script&lang=js&"
export * from "./VueTabs.vue?vue&type=script&lang=js&"
import style0 from "./VueTabs.vue?vue&type=style&index=0&id=ad8933de&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad8933de",
  null
  
)

export default component.exports